import { Button } from '@/components/Button';
import { MdAdd } from 'react-icons/md';
import { useNavigate } from '@tanstack/react-router';
import useFetchJobSources from '../api/useFetchJobSources';
import LinkedAccountsDatabaseList from '../components/LinkedAccountsDatabaseList';
import LinkedAccountsList from '../components/LinkedAccountsList';
import LinkedAccountsNoData from '../components/LinkedAccountsNoData';
import LinkedAccountsTabs from '../components/LinkedAccountsTabs';

type Props = {
  serviceType: 'normal' | 'database';
};

export default function LinkedAccountsTemplate({ serviceType }: Props) {
  const navigate = useNavigate();
  const { data, isLoading } = useFetchJobSources(serviceType);

  const handleAddClick = () => {
    navigate({ to: '/agent/linked_accounts/new' });
  };

  const jobSources = data?.data ?? [];

  return (
    <div className="flex flex-col gap-6 px-6 py-3">
      <div className="flex items-center justify-between">
        <LinkedAccountsTabs serviceType={serviceType} />
        <Button type="button" className="h-[42px]" onClick={handleAddClick}>
          <MdAdd size={20} />
          連携先追加
        </Button>
      </div>
      {!isLoading && jobSources.length === 0 ? (
        <div className="flex h-[calc(100vh_-_200px)] items-center justify-center">
          <LinkedAccountsNoData onClickModal={handleAddClick} />
        </div>
      ) : serviceType === 'database' ? (
        <LinkedAccountsDatabaseList jobSources={jobSources} />
      ) : (
        <LinkedAccountsList jobSources={jobSources} />
      )}
    </div>
  );
}
